<template>
  <CollapsibleCard
    :editable="editable"
    :editing="editing"
  >

    <template v-slot:header> Företagsuppgifter </template>

    <template v-slot:info>
      {{ get(company, 'name', '') }} {{ get(company, 'organizationalNumber', '') | filterOrgNo }}, {{ get(company, 'contracttype.name', '') }}
    </template>

    <template v-slot:detailsinfo></template>

    <template v-slot:editinfo>Företagsnamn, organisationsnummer och avtalstyp.</template>

    <template v-slot:view>
      <ApplicationCompanyView
        :company="company"
        :application="application"
      />
    </template>

    <template v-slot:edit>
      <ApplicationCompanyEdit
        ref="edit"
        :application="application"
        :initApplicationCompanyState="initApplicationCompanyState"
        @change-application="application = $event"
        @change-company-state="initApplicationCompanyState = $event"
        @saved="saved()"
      />
    </template>

    <template v-slot:cancel>
      <v-btn
        color="secondary"
        @click="cancelChangeCompany()"
      >
        <v-icon>$sl-cancel</v-icon>Avbryt
      </v-btn>
    </template>

    <template v-slot:save>
      <v-btn
        data-cy="save-application"
        @click="$refs.edit.saveChangeCompany()"
      >
        <v-icon>$sl-check</v-icon>Spara
      </v-btn>
    </template>

  </CollapsibleCard>
</template>

<script>
import pick from 'lodash/pick'
import get from 'lodash/get'
import CollapsibleCard from '@/components/common/CollapsibleCard'
import MessageBox from '@/components/common/MessageBox.vue'
import {mapGetters} from 'vuex'
import {RulesMixin, InstructorAbilities, Utilities} from '@/components/mixins'
import ApplicationCompanyView from './ApplicationCompanyView.vue'
import ApplicationCompanyEdit from './ApplicationCompanyEdit.vue'

// @group Application
// ApplicationCompany component
export default {
  name: 'ApplicationCompany',

  mixins: [RulesMixin, InstructorAbilities, Utilities],

  components: {
    MessageBox,
    CollapsibleCard,
    ApplicationCompanyView,
    ApplicationCompanyEdit
  },

  props: {
    editMode: {
      // `true` / `false`
      type: Boolean,
      // The default value is: `false`
      default: false
    },
    editable: {
      type: Boolean,
      default: false
    },
  },

  data: () => ({
    firstLoad: true,
    company: {},
    initApplicationCompanyState: {},
    application: null,
    fields: [
      'id',
      'instructorId',
      'workplaceId',
      'companyId',
      'departmentId',
      'organizationalNumber',
      'state',
      'stateId',
      'isCompanyApplication'
    ],
    editing: null
  }),

  created() {
    this.initApplicationCompany()
  },

  computed: {
    ...mapGetters('application', [
      'selectedApplication',
      'applicationCompany',
      'applicationWorkplace',
      'applicationDepartments'
    ])
  },

  methods: {
    get,
    saved() {
      this.editing = false
      this.$emit('saved')
    },

    initApplicationCompany() {
      console.log('initApplicationCompany ', this.firstLoad)

      if (this.selectedApplication && this.selectedApplication.id) {
        this.application = pick(this.selectedApplication, this.fields)
      } else {
        this.application = Object.fromEntries(
          this.fields.map(f => {
            return [f, null]
          })
        )
      }
      this.company = this.applicationCompany || {contracttype: {}}
      this.$set(this.application, 'organizationalNumber', this.company.organizationalNumber)
      this.initApplicationCompanyState.organizationalNumber = this.company.organizationalNumber
    },

    changeCompany() {
      this.initApplicationCompanyStateLocal = cloneDeep(this.applicationLocal)
      this.editing = true
    },

    cancelChangeCompany() {
      console.log('this.initApplicationCompanyState', this.initApplicationCompanyState)
      this.initApplicationCompany()
      this.editing = false
    }
  }
}
</script>

<style scoped>
</style>